// Canada Visa PDF export using browser print (HTML → PDF)
// This approach correctly renders Mongolian Cyrillic text

const FIELD_LABELS: Record<string, string> = {
  purpose: "Зорилго",
  purposeOther: "Зорилго (бусад)",
  travelGroup: "Аяллын бүлэг",
  groupCount: "Бүлгийн тоо",
  applyingFrom: "Өргөдөл гаргах улс",
  currentCountry: "Одоогийн амьдарч байгаа улс",
  serviceFor: "Үйлчилгээ авах хүн",
  prevCanadaApp: "Өмнөх Канадын өргөдөл",
  prevAppType: "Өргөдлийн төрөл",
  prevAppYear: "Өргөдлийн он",
  prevAppDecision: "Шийдвэр",
  prevUCI: "Өмнөх UCI дугаар",
  hasUCI: "UCI дугаар байгаа эсэх",
  uciNumber: "UCI дугаар",
  hasBiometrics: "Биометрик өгсөн эсэх",
  biometricYear: "Биометрик өгсөн он",
  biometricCountry: "Биометрик өгсөн улс",
  fullNameMongolian: "Монгол нэр",
  lastNameLatin: "Овог (латин)",
  firstNameLatin: "Нэр (латин)",
  dob: "Төрсөн огноо",
  birthCity: "Төрсөн хот",
  birthCountry: "Төрсөн улс",
  citizenship: "Иргэншил",
  otherCitizenship: "Бусад иргэншил",
  gender: "Хүйс",
  passportNumber: "Паспортын дугаар",
  passportIssueDate: "Паспорт олгосон огноо",
  passportExpiry: "Паспортын хугацаа дуусах огноо",
  passportCountry: "Паспорт олгосон улс",
  hasNationalId: "Иргэний үнэмлэх байгаа эсэх",
  nationalIdNumber: "Иргэний үнэмлэхийн дугаар",
  nationalIdCountry: "Иргэний үнэмлэх олгосон улс",
  email: "Имэйл",
  phone: "Утас",
  altPhone: "Нэмэлт утас",
  addressStreet: "Гудамж, байр",
  addressCity: "Хот",
  addressCountry: "Оршин суугаа улс",
  addressPostal: "Шуудангийн код",
  isCitizenOfCurrentCountry: "Одоогийн улсын иргэн мөн үү",
  currentStatusType: "Одоогийн статус",
  statusExpiry: "Статусын хугацаа",
  livedAbroadLast5: "Сүүлийн 5 жилд гадаадад амьдарсан уу",
  abroadHistoryText: "Гадаадад амьдарсан түүх",
  maritalStatus: "Гэр бүлийн байдал",
  spouseLastName: "Эхнэр/нөхрийн овог",
  spouseFirstName: "Эхнэр/нөхрийн нэр",
  spouseDob: "Эхнэр/нөхрийн төрсөн огноо",
  spouseBirthCountry: "Эхнэр/нөхрийн төрсөн улс",
  spouseCitizenship: "Эхнэр/нөхрийн иргэншил",
  spousePassport: "Эхнэр/нөхрийн паспортын дугаар",
  fatherLastName: "Эцгийн овог",
  fatherFirstName: "Эцгийн нэр",
  fatherDob: "Эцгийн төрсөн огноо",
  fatherBirthCountry: "Эцгийн төрсөн улс",
  fatherCurrentLocation: "Эцгийн одоогийн байршил",
  fatherOccupation: "Эцгийн ажил мэргэжил",
  fatherAlive: "Эцэг амьд эсэх",
  motherLastName: "Эхийн овог",
  motherFirstName: "Эхийн нэр",
  motherDob: "Эхийн төрсөн огноо",
  motherBirthCountry: "Эхийн төрсөн улс",
  motherCurrentLocation: "Эхийн одоогийн байршил",
  motherOccupation: "Эхийн ажил мэргэжил",
  motherAlive: "Эх амьд эсэх",
  hasChildren: "Хүүхэд байгаа эсэх",
  childrenText: "Хүүхдийн мэдээлэл",
  hasSiblings: "Ах эгч дүү байгаа эсэх",
  siblingsText: "Ах эгч дүүгийн мэдээлэл",
  hasHigherEdu: "Дээд боловсрол байгаа эсэх",
  educationHistoryText: "Боловсролын түүх",
  workHistoryText: "Ажлын түүх",
  arrivalDate: "Явах огноо",
  departureDate: "Буцах огноо",
  stayDuration: "Хугацаа",
  stayAddress: "Байрших хаяг",
  fundsAvailable: "Боломжтой мөнгөн дүн",
  hasInviter: "Урьж байгаа хүн байгаа эсэх",
  inviterName: "Урьж байгаа хүний нэр",
  inviterRelation: "Холбоо",
  inviterAddress: "Хаяг",
  inviterPhone: "Утас",
  inviterStatus: "Канад дахь статус",
  travelHistoryText: "Аяллын түүх",
  visaRefused: "Виз татгалзсан эсэх",
  visaRefusedDetail: "Татгалзлын дэлгэрэнгүй",
  entryRefused: "Хилээр нэвтрүүлэхээс татгалзсан эсэх",
  entryRefusedDetail: "Татгалзлын дэлгэрэнгүй",
  deportedOrRemoved: "Хөөгдсөн эсэх",
  deportedDetail: "Хөөгдлийн дэлгэрэнгүй",
  hasHealthCondition: "Эрүүл мэндийн байдал",
  healthDetail: "Эрүүл мэндийн дэлгэрэнгүй",
  convicted: "Гэмт хэрэгт ялласан эсэх",
  convictedDetail: "Ялласны дэлгэрэнгүй",
  arrested: "Баривчлагдсан эсэх",
  arrestedDetail: "Баривчлагдсаны дэлгэрэнгүй",
  militaryService: "Цэргийн алба",
  militaryDetail: "Цэргийн алба дэлгэрэнгүй",
  monthlyIncome: "Сарын орлого",
  incomeSource: "Орлогын эх үүсвэр",
  bankBalance: "Дансны үлдэгдэл",
  tiesText: "Эх орондоо буцах холбоо",
  signatureName: "Гарын үсэг (нэр)",
  submittedAt: "Илгээсэн огноо",
};

const SECTIONS: [string, string[]][] = [
  ["Ерөнхий мэдээлэл", ["purpose", "purposeOther", "travelGroup", "groupCount", "applyingFrom", "currentCountry", "serviceFor"]],
  ["Өмнөх Канадын өргөдөл", ["prevCanadaApp", "prevAppType", "prevAppYear", "prevAppDecision", "prevUCI"]],
  ["UCI / Биометрик", ["hasUCI", "uciNumber", "hasBiometrics", "biometricYear", "biometricCountry"]],
  ["Хувийн мэдээлэл", ["fullNameMongolian", "lastNameLatin", "firstNameLatin", "dob", "birthCity", "birthCountry", "citizenship", "otherCitizenship", "gender"]],
  ["Паспортын мэдээлэл", ["passportNumber", "passportIssueDate", "passportExpiry", "passportCountry", "hasNationalId", "nationalIdNumber", "nationalIdCountry"]],
  ["Холбоо барих", ["email", "phone", "altPhone", "addressStreet", "addressCity", "addressCountry", "addressPostal"]],
  ["Одоогийн статус", ["isCitizenOfCurrentCountry", "currentStatusType", "statusExpiry", "livedAbroadLast5", "abroadHistoryText"]],
  ["Гэр бүлийн байдал", ["maritalStatus", "spouseLastName", "spouseFirstName", "spouseDob", "spouseBirthCountry", "spouseCitizenship", "spousePassport"]],
  ["Эцэг, эхийн мэдээлэл", ["fatherLastName", "fatherFirstName", "fatherDob", "fatherBirthCountry", "fatherCurrentLocation", "fatherOccupation", "fatherAlive", "motherLastName", "motherFirstName", "motherDob", "motherBirthCountry", "motherCurrentLocation", "motherOccupation", "motherAlive"]],
  ["Хүүхэд, ах эгч дүү", ["hasChildren", "childrenText", "hasSiblings", "siblingsText"]],
  ["Боловсрол", ["hasHigherEdu", "educationHistoryText"]],
  ["Ажлын түүх", ["workHistoryText"]],
  ["Канад руу явах төлөвлөгөө", ["arrivalDate", "departureDate", "stayDuration", "stayAddress", "fundsAvailable"]],
  ["Урьж байгаа хүн", ["hasInviter", "inviterName", "inviterRelation", "inviterAddress", "inviterPhone", "inviterStatus"]],
  ["Аяллын түүх", ["travelHistoryText"]],
  ["Визний татгалзал", ["visaRefused", "visaRefusedDetail", "entryRefused", "entryRefusedDetail", "deportedOrRemoved", "deportedDetail"]],
  ["Эрүүл мэнд", ["hasHealthCondition", "healthDetail"]],
  ["Гэмт хэрэг, цэрэг", ["convicted", "convictedDetail", "arrested", "arrestedDetail", "militaryService", "militaryDetail"]],
  ["Санхүүгийн мэдээлэл", ["monthlyIncome", "incomeSource", "bankBalance"]],
  ["Эх орондоо буцах холбоо", ["tiesText"]],
  ["Гарын үсэг", ["signatureName", "submittedAt"]],
];

const DOC_LABELS: Record<string, string> = {
  passport: "Гадаад паспорт",
  irgenii_unmehleh: "Иргэний үнэмлэх",
  gerleltiin_gerchilgee: "Гэрлэлтийн гэрчилгээ / эх хувь",
  ajliin_todorkhiilolt: "Ажлын газрын тодорхойлолт",
  business_docs: "Бизнесийн баримт",
  nd_khulga: "НД хуулга",
  dans_khulga: "Дансны хуулга",
  khadgalamj: "Хадгаламж",
  ul_khodlokh: "Үл хөдлөх лавлагаа",
  busad_sankhuu: "Бусад санхүү",
  photo: "Цээж зураг",
};

const STATUS_LABELS: Record<string, string> = {
  new: "Шинэ", in_progress: "Бөглөж байгаа", submitted: "Илгээсэн",
  reviewing: "Шалгаж байгаа", info_needed: "Мэдээлэл дутуу", docs_needed: "Баримт дутуу",
  complete: "Материал бүрэн", ready: "Өргөдөл бэлэн", filed: "Эцэслэн илгээсэн",
  pending_decision: "Шийдвэр хүлээж байгаа", approved: "Зөвшөөрөгдсөн", rejected: "Татгалзсан",
};

interface AppData {
  id: number;
  clientName?: string | null;
  clientEmail?: string | null;
  clientPhone?: string | null;
  status: string;
  createdAt: Date | string;
  submittedAt?: Date | string | null;
  formData?: string | null;
  adminNote?: string | null;
  documents?: Array<{ category: string; fileName: string; fileUrl: string }>;
}

function esc(str: string): string {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function formatValue(val: unknown): string {
  if (val === undefined || val === null || val === "") return "—";
  if (typeof val === "boolean") return val ? "Тийм" : "Үгүй";
  return String(val);
}

export function generateCanadaVisaPDF(app: AppData) {
  let formData: Record<string, unknown> = {};
  try { formData = JSON.parse(app.formData ?? "{}"); } catch { /* empty */ }

  const clientName = app.clientName || "—";
  const createdDate = new Date(app.createdAt).toLocaleDateString("mn-MN");
  const submittedDate = app.submittedAt ? new Date(app.submittedAt).toLocaleDateString("mn-MN") : "—";
  const statusLabel = STATUS_LABELS[app.status] ?? app.status;

  // Build sections HTML — show ALL fields, even empty ones
  let sectionsHtml = "";
  for (const [sectionTitle, keys] of SECTIONS) {
    const rows = keys.map(k => `
      <tr>
        <td class="label-cell">${esc(FIELD_LABELS[k] ?? k)}</td>
        <td class="value-cell">${esc(formatValue(formData[k]))}</td>
      </tr>
    `).join("");

    sectionsHtml += `
      <div class="section">
        <div class="section-header">${esc(sectionTitle)}</div>
        <table class="data-table">
          <tbody>${rows}</tbody>
        </table>
      </div>
    `;
  }

  // Documents section
  let docsHtml = "";
  if (app.documents && app.documents.length > 0) {
    const docRows = app.documents.map(d => `
      <tr>
        <td class="label-cell">${esc(DOC_LABELS[d.category] ?? d.category)}</td>
        <td class="value-cell">${esc(d.fileName)}</td>
      </tr>
    `).join("");
    docsHtml = `
      <div class="section">
        <div class="section-header">Оруулсан файлууд (${app.documents.length})</div>
        <table class="data-table">
          <tbody>${docRows}</tbody>
        </table>
      </div>
    `;
  } else {
    docsHtml = `
      <div class="section">
        <div class="section-header">Оруулсан файлууд</div>
        <table class="data-table">
          <tbody><tr><td class="label-cell" colspan="2" style="color:#94a3b8;font-style:italic;">Файл оруулаагүй</td></tr></tbody>
        </table>
      </div>
    `;
  }

  // Admin note
  let noteHtml = "";
  if (app.adminNote) {
    noteHtml = `
      <div class="section admin-note">
        <div class="section-header note-header">Дотоод тэмдэглэл</div>
        <p class="note-text">${esc(app.adminNote)}</p>
      </div>
    `;
  }

  const html = `<!DOCTYPE html>
<html lang="mn">
<head>
  <meta charset="UTF-8">
  <title>Канадын виз — ${esc(clientName)}</title>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;600;700&display=swap');
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body {
      font-family: 'Noto Sans', 'Arial Unicode MS', Arial, sans-serif;
      font-size: 10pt;
      color: #1e293b;
      background: #fff;
    }
    .header {
      background: #1e3a8a;
      color: white;
      padding: 14px 20px 10px;
    }
    .header h1 { font-size: 16pt; font-weight: 700; margin-bottom: 3px; }
    .header p { font-size: 9pt; opacity: 0.85; }
    .client-bar {
      background: #eff6ff;
      border-bottom: 1px solid #bfdbfe;
      padding: 10px 20px;
    }
    .client-name { font-size: 13pt; font-weight: 700; color: #1e3a8a; margin-bottom: 4px; }
    .client-meta { font-size: 8.5pt; color: #475569; display: flex; gap: 18px; flex-wrap: wrap; }
    .status-badge {
      display: inline-block;
      background: #1e3a8a;
      color: white;
      padding: 1px 8px;
      border-radius: 10px;
      font-size: 8pt;
      font-weight: 600;
    }
    .content { padding: 12px 20px; }
    .section { margin-bottom: 10px; break-inside: avoid; }
    .section-header {
      background: #dbeafe;
      color: #1e3a8a;
      font-weight: 700;
      font-size: 9pt;
      padding: 4px 8px;
      border-left: 3px solid #1e3a8a;
    }
    .data-table { width: 100%; border-collapse: collapse; font-size: 9pt; }
    .data-table tr:nth-child(even) { background: #f8fafc; }
    .label-cell {
      width: 42%;
      padding: 4px 8px;
      font-weight: 600;
      color: #475569;
      border: 0.5px solid #e2e8f0;
      vertical-align: top;
    }
    .value-cell {
      width: 58%;
      padding: 4px 8px;
      color: #1e293b;
      border: 0.5px solid #e2e8f0;
      vertical-align: top;
      white-space: pre-wrap;
      word-break: break-word;
    }
    .value-empty {
      color: #94a3b8;
      font-style: italic;
    }
    .admin-note { margin-top: 12px; }
    .note-header { background: #fef9c3 !important; color: #854d0e !important; border-left-color: #ca8a04 !important; }
    .note-text {
      background: #fefce8;
      border: 0.5px solid #fde047;
      padding: 8px;
      font-size: 9pt;
      color: #713f12;
      white-space: pre-wrap;
    }
    .footer {
      text-align: center;
      font-size: 7.5pt;
      color: #94a3b8;
      padding: 10px 20px;
      border-top: 1px solid #e2e8f0;
      margin-top: 10px;
    }
    @media print {
      @page { margin: 12mm 10mm; size: A4; }
      body { font-size: 9pt; }
      .header, .client-bar, .section-header, .data-table tr:nth-child(even), .note-text {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
    }
  </style>
</head>
<body>
  <div class="header">
    <h1>Канадын виз — Өргөдлийн мэдээлэл</h1>
    <p>United Dream Mongolia — dreamvisamgl.com</p>
  </div>
  <div class="client-bar">
    <div class="client-name">${esc(clientName)}</div>
    <div class="client-meta">
      ${app.clientEmail ? `<span>${esc(app.clientEmail)}</span>` : ""}
      ${app.clientPhone ? `<span>${esc(app.clientPhone)}</span>` : ""}
      <span><span class="status-badge">${esc(statusLabel)}</span></span>
      <span>ID: #${app.id}</span>
      <span>Үүсгэсэн: ${createdDate}</span>
      <span>Илгээсэн: ${submittedDate}</span>
    </div>
  </div>
  <div class="content">
    ${sectionsHtml}
    ${docsHtml}
    ${noteHtml}
  </div>
  <div class="footer">
    United Dream Mongolia &nbsp;|&nbsp; dreamvisamgl.com &nbsp;|&nbsp; Хэвлэсэн огноо: ${new Date().toLocaleDateString("mn-MN")}
  </div>
  <script>
    // Style empty values
    document.querySelectorAll('.value-cell').forEach(function(el) {
      if (el.textContent && el.textContent.trim() === '—') {
        el.classList.add('value-empty');
      }
    });
    window.onload = function() { window.print(); };
  </script>
</body>
</html>`;

  const printWindow = window.open("", "_blank", "width=900,height=700");
  if (!printWindow) {
    alert("Pop-up блоклогдлоо. Хөтчийн pop-up зөвшөөрлийг идэвхжүүлнэ үү.");
    return;
  }
  printWindow.document.write(html);
  printWindow.document.close();
}
